import { Directive, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {
    IChecklist2ReportAnswer,
    IChecklist2ReportAttentionRequired,
    IChecklist2ReportChecklistSummary,
    IChecklistScheduleForReport,
    IChecklistV2FilterAvailableItems,
    IChecklistV2ReportParameter,
    IChecklistV2ReportParameterFilter,
} from './fi-checklist2-report';
import { BehaviorSubject, Subject } from 'rxjs';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { FiChecklist2ReportHelperService } from '../services/fi-checklist2-report-helper.service';
import { fiIntersection } from '../../../utils/fi-intersection';
import { FiChecklist2ReportFilterService } from '../services/fi-checklist2-report-filter.service';
import { ChecklistV2ReportPages } from '../enums/fi-checklist2-report-pages.enum';
import { FiChecklist2ReportData } from './fi-checklist2-report-data';
import { FiChecklist2ReportDialogsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-dialogs.service';
import { FiChecklist2ReportDataService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-data.service';
import { FiChecklist2ReportOpenChecklistsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-open-checklists.service';
import { ChecklistWidgetTableFilterDataService } from '@fi-shared/checklist/fi-checklist2-report/components/shared/widget-table-filter-data.service';

@Directive()
export class FiChecklist2ReportDetailsViewerBase implements OnInit, OnDestroy {
    @Output() showWidgetDetails = new EventEmitter<void>();
    @Input() reportParameter: IChecklistV2ReportParameter;
    @Input() reportData: FiChecklist2ReportData;
    @Input() checklistSummary: IChecklist2ReportChecklistSummary;
    @Input() currentFilter: IChecklistV2ReportParameterFilter;
    @Input() reportPage: ChecklistV2ReportPages;
    @Input() answerDetails: IChecklist2ReportAnswer[];
    readonly headerIconClassName: string = 'fas fa-chevron-down';
    isChecklistInfoInformationVisible$ = new BehaviorSubject<boolean>(true);
    checklistReportHeaderSettings: EditTabsModel;
    protected fiChecklist2ReportHelperService: FiChecklist2ReportHelperService;
    protected fiChecklist2ReportFilterService: FiChecklist2ReportFilterService;
    protected fiChecklist2ReportDialogsService: FiChecklist2ReportDialogsService;
    protected fiChecklist2ReportDataService: FiChecklist2ReportDataService;
    protected fiChecklist2ReportOpenChecklistsService: FiChecklist2ReportOpenChecklistsService;
    protected widgetTableFilterDataService: ChecklistWidgetTableFilterDataService;

    get availableItems(): IChecklistV2FilterAvailableItems {
        return this.reportData.availableItems;
    }

    get openChecklistsSummary(): IChecklist2ReportChecklistSummary[] {
        return this.reportData.getOpenChecklistsSummary(this.reportParameter.Id);
    }
    get deviationsSummary(): IChecklist2ReportAttentionRequired[] {
        return this.reportData.getDeviationsSummary(this.reportParameter.Id);
    }
    constructor(protected injector: Injector) {}

    ngOnInit() {
        this.setServices();
        /*this._initialReportData = cloneDeep(this.reportData);
        this._initialReportData.AvailableAreas = fiItemsFlatten(this._initialReportData.AvailableAreas);*/
        this.checklistReportHeaderSettings = new EditTabsModel(this.checklistSummary.ChecklistName);
        this.setInitialFilterData();
        this.updateFilterDataByScheduleAccessRights();
    }

    private setServices() {
        this.fiChecklist2ReportHelperService = this.injector.get(FiChecklist2ReportHelperService);
        this.fiChecklist2ReportFilterService = this.injector.get(FiChecklist2ReportFilterService);
        this.fiChecklist2ReportDialogsService = this.injector.get(FiChecklist2ReportDialogsService);
        this.fiChecklist2ReportDataService = this.injector.get(FiChecklist2ReportDataService);
        this.fiChecklist2ReportOpenChecklistsService = this.injector.get(FiChecklist2ReportOpenChecklistsService);
        this.widgetTableFilterDataService = this.injector.get(ChecklistWidgetTableFilterDataService);
    }

    updateFilterDataByScheduleAccessRights() {
        /*const currentSchedule: IChecklistScheduleForReport = this.getCurrentSchedule();
        this.currentFilter.BusinessUnitIds = this.currentFilter.BusinessUnitIds?.filter((businessUnitId: number) => {
            return this.isScheduleSharedToBusinessUnit(currentSchedule, businessUnitId);
        });
        this.currentFilter.AreaIds = this.currentFilter.AreaIds?.filter((areaId: number) => {
            return this.isScheduleSharedToArea(currentSchedule, areaId);
        });
        this.currentFilter.BusinessAreaIds = this.currentFilter.BusinessAreaIds?.filter((businessAreaId: number) => {
            return this.isScheduleSharedToBusinessArea(currentSchedule, businessAreaId);
        });

        this.reportData = {...this._initialReportData};*/
        /*const _availableBusinessUnits: IBusinessUnitForReport[] = this.getAvailableBusinessUnits();
        const _availableAreaIdsByBusinessUnits: number[] = _availableBusinessUnits
            .map((unit: IBusinessUnitForReport) => unit.AreaId);*/
        /*this.reportData.AvailableBusinessUnits = _availableBusinessUnits
            .filter((availableBusinessUnit: IBusinessUnitForReport) => {
                return this.isScheduleSharedToBusinessUnit(currentSchedule, availableBusinessUnit.Id);
            });*/
        /*this.reportData.AvailableAreas = this._initialReportData.AvailableAreas.filter((availableArea) => {
            return _availableAreaIdsByBusinessUnits.includes(availableArea.Id) && this.isScheduleSharedToArea(currentSchedule, availableArea.Id);
        });*/
        /*const _availableBusinessAreaIds: number[] = flatten(_availableBusinessUnits.map((unit) => {
            return unit.BusinessAreaIds
        }));*/
        /*this.reportData.AvailableBusinessAreas = this._initialReportData.AvailableBusinessAreas.filter((availableBusinessArea) => {
            return _availableBusinessAreaIds.includes(availableBusinessArea.Id) && this.isScheduleSharedToBusinessArea(currentSchedule, availableBusinessArea.Id);
        });*/
    }

    protected setInitialFilterData() {
        if (this.currentFilter.ChecklistIds?.length !== 1) {
            this.currentFilter.ChecklistIds = [this.checklistSummary.ChecklistId];
        }

        if (!this.currentFilter.ScheduleIds?.length) {
            this.currentFilter.ScheduleIds = [this.checklistSummary.ScheduleId];
        }
    }

    protected getHeaderIconClass(): string {
        return this.isChecklistInfoInformationVisible$.value
            ? this.headerIconClassName + ' rotated'
            : this.headerIconClassName;
    }

    protected toggleChecklistInfoVisibility() {
        this.isChecklistInfoInformationVisible$.next(!this.isChecklistInfoInformationVisible$.value);
    }

    protected back() {
        this.showWidgetDetails.emit();
    }

    protected isEmptyFilter(filter: IChecklistV2ReportParameterFilter): boolean {
        return (
            !this.doesFilterIncludeBusinessUnitIds(filter) &&
            !this.doesFilterIncludeAreaIds(filter) &&
            !this.doesFilterIncludeBusinessAreaIds(filter)
        );
    }

    protected doesFilterIncludeBusinessUnitIds(filter: IChecklistV2ReportParameterFilter): boolean {
        return !!filter.BusinessUnitIds?.length;
    }

    protected doesFilterIncludeAreaIds(filter: IChecklistV2ReportParameterFilter): boolean {
        return !!filter.AreaIds?.length;
    }

    protected doesFilterIncludeBusinessAreaIds(filter: IChecklistV2ReportParameterFilter): boolean {
        return !!filter.BusinessAreaIds?.length;
    }

    protected getAreaAndBusinessAreaUnitIntersection(areaIds: number[], businessAreaIds: number[]): number[] {
        // note: if one of arrays is empty fiIntersection will return empty array
        if (!businessAreaIds.length) return areaIds;

        if (!areaIds.length) return businessAreaIds;

        return fiIntersection<number>(areaIds, businessAreaIds);
    }

    getWidgetDescription(skipCustomDescription: boolean = false): string {
        return this.fiChecklist2ReportHelperService.getWidgetDescription(this.reportParameter, skipCustomDescription);
    }

    protected ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.fiChecklist2ReportHelperService.setPageNavBarVisibility(false);
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
